/**
 * The metric id an open-end classifier's per-asset score lives under:
 * `metric_<stableKey>__<metricKind>`. The composite builder declares a
 * component with it before any respondent answers, and canonical analysis
 * writes the score under the same id
 * (`canonical_analysis.open_end_classifier.synthetic_metric_id`). The double
 * underscore keeps it apart from matrix ids (`metric_<stableKey>_<measureId>`).
 */
export function openEndClassifierMetricId(
  stableKey: string,
  metricKind: string,
): string {
  return `metric_${stableKey}__${metricKind}`;
}
